import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CourtTypesRoutingModule } from './court-types-routing.module';
import { CourtTypeListComponent } from './components/court-type-list/court-type-list.component';
import { CourtTypeFormComponent } from './components/court-type-form/court-type-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { SearchComponent } from '../../shared/components/search/search.component';


@NgModule({
  declarations: [
    CourtTypeListComponent,
    CourtTypeFormComponent
  ],
  imports: [
    CommonModule,
    CourtTypesRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatIconModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule, // This provides the native DateAdapter
    MatSelectModule,
    MatOptionModule, // This is optional, often included via MatSelectModule
    MatCheckboxModule,
    SearchComponent,
  ]
})
export class CourtTypesModule { }
